import  * as InstrumentConnectivityConstants from './InstrumentConnectivityConstants';
import AppService from 'Global/AppService';

export const addDeviceToInstrumentConnReducerState = (instanceId) => {
	return {
		type: InstrumentConnectivityConstants.INSTRUMENT_CONN_DEVICE_STATE_ADD,
		payload: instanceId
	}
};

export const removeDeviceFromInstrumentConnReducerState = (instanceId) => {
	return {
		type: InstrumentConnectivityConstants.INSTRUMENT_CONN_DEVICE_STATE_REMOVE,
		payload: instanceId
	}
};

export const fetchInstConnStatus = (url, payload, instanceId) => {
    return (dispatch) => {
        dispatch({ type: InstrumentConnectivityConstants.INSTRUMENT_CONN_STATUS_REQUEST, payload: { instanceId, newState: payload } });
        function callback(success, err) {
            if (success.result) {
                dispatch({ type: InstrumentConnectivityConstants.INSTRUMENT_CONN_STATUS_SUCCESS, payload: { instanceId, newState: success.result } });
            } else {
                dispatch({ type: InstrumentConnectivityConstants.INSTRUMENT_CONN_STATUS_FAILURE, payload: { instanceId, newState: err.responseJSON } });
            }
        }
        AppService.postData(payload, url, callback);
    }
}
